import React, { Component } from "react";
import { Link } from "react-router-dom";
class Sidebar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <a href="/apps/sportter">
                    <span className="text">Sportter</span>
                  </a>
                </li>
                <li className="list-item">
                  <span className="text">Kako dodati klub?</span>
                </li>
                <li className="list-item">
                  <span className="text">Što je profil igrača?</span>
                </li>
                <li className="list-item">
                  <span className="text">Kako dodati ili izmjeniti podtke</span>
                </li>
                <li className="list-item">
                  <span className="text">Natjecanja</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="widget widget_help align-center has-shadow no-sep has-border border-solid">
            <div className="inner">
              <h2 className="widget-title margin-bottom-14">
                <span>Kako Vam mogu pomoći?</span>
              </h2>
              <p className="text line-height-26 margin-bottom-23">
                <img
                  src="../assets/img/employees/ante.png"
                  alt="Katarina Babić, CityX Apps"
                />
                <br />
                <br />
                Za ugovaranje Sportter-a u Vašem klubu rado će Vam pomoći{" "}
                <b>Ante Mamić</b>.
              </p>
              <div className="elm-button">
                <a href="/contact" className="themesflat-button bg-accent pd30">
                  KONTAKTIRAJTE ME
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default Sidebar;
